var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWebhookSubscription = function SvgWebhookSubscription(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 104,
    viewBox: "0 0 96 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10345_110459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 56.4767C47.3961 56.1776 48.0797 56.1753 48.6562 56.4703L75.5213 70.2196C76.973 70.9626 76.973 73.0374 75.5213 73.7804L48.6562 87.5297C48.0797 87.8247 47.3961 87.8224 46.8216 87.5233L20.4081 73.774C18.9727 73.0269 18.9727 70.9731 20.4081 70.226L46.8216 56.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10345_110459",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 13.1547C47.4145 12.4402 48.9393 12.4402 50.1769 13.1547L77.3538 28.8453C78.5914 29.5598 79.3538 30.8803 79.3538 32.3094V63.6906C79.3538 65.1197 78.5914 66.4402 77.3538 67.1547L50.1769 82.8453C48.9393 83.5598 47.4145 83.5598 46.1769 82.8453L19.0008 67.1547C17.7633 66.4402 17.0009 65.1197 17.0008 63.6907L17.0001 32.3095C17 30.8804 17.7624 29.5598 19.0001 28.8453L46.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10345_110459)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2139 12)",
    fill: "url(#paint0_linear_10345_110459)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6469 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2139 48)",
    fill: "url(#paint1_linear_10345_110459)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2719 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10345_110459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6833 53.8619C67.7435 53.7142 67.7765 53.5656 67.7789 53.4315C67.7813 53.2975 67.7531 53.1828 67.697 53.0994C67.641 53.0159 67.5592 52.9666 67.4601 52.9567C67.361 52.9467 67.2482 52.9764 67.1333 53.0427L64.9376 54.3104L64.9376 47.7479L60.2975 59.1345C60.2373 59.2823 60.2042 59.4308 60.2018 59.5649C60.1994 59.6989 60.2277 59.8136 60.2837 59.897C60.3398 59.9804 60.4216 60.0296 60.5207 60.0394C60.6198 60.0493 60.7327 60.0195 60.8476 59.953L63.0432 58.6854L63.0432 65.2479L67.6833 53.8619Z",
    fill: "url(#paint2_linear_10345_110459)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6833 53.8619C67.7435 53.7142 67.7765 53.5656 67.7789 53.4315C67.7813 53.2975 67.7531 53.1828 67.697 53.0994C67.641 53.0159 67.5592 52.9666 67.4601 52.9567C67.361 52.9467 67.2482 52.9764 67.1333 53.0427L64.9376 54.3104L64.9376 47.7479L60.2975 59.1345C60.2373 59.2823 60.2042 59.4308 60.2018 59.5649C60.1994 59.6989 60.2277 59.8136 60.2837 59.897C60.3398 59.9804 60.4216 60.0296 60.5207 60.0394C60.6198 60.0493 60.7327 60.0195 60.8476 59.953L63.0432 58.6854L63.0432 65.2479L67.6833 53.8619Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0381 30)",
    fill: "url(#paint3_linear_10345_110459)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0961 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6769 14.0207L76.8538 29.7113C77.782 30.2472 78.3538 31.2376 78.3538 32.3094V63.6906C78.3538 64.7624 77.782 65.7528 76.8538 66.2887L49.6769 81.9793C48.7487 82.5152 47.6051 82.5152 46.6769 81.9792L19.5008 66.2887C18.5727 65.7528 18.0009 64.7624 18.0008 63.6907L18.0001 32.3094C18 31.2376 18.5718 30.2472 19.5001 29.7113L46.6769 14.0207C47.6051 13.4848 48.7487 13.4848 49.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10345_110459",
    x: 3.33154,
    y: 40.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.552941 0 0 0 0 0.0313726 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10345_110459"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10345_110459",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10345_110459",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCC75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDAC42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10345_110459",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10345_110459",
    x1: 67.7791,
    y1: 62.5091,
    x2: 57.4286,
    y2: 59.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10345_110459",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB24B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10345_110459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 56.4126 52.125)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWebhookSubscription);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "webhook_subscription.9b656f46b53340e1676bd23b67c5617d.svg";